import { Spiner } from "@components/loaders/spiner";
import { FinanceService } from "@services/finance.service";
import { SchoolService } from "@services/school.service";
import { useThemeStore } from "@stores/theme.store";
import { useQuery } from "@tanstack/react-query";
import { toRp } from "@utils/helper";
import moment from "moment-timezone";
import { useEffect } from "react";
import { FcFinePrint } from "react-icons/fc";
moment.locale("id");

export const DebtBillPage = () => {
  const { setHeader, setBottomNavigation } = useThemeStore((state) => state);

  const { data: dataNis } = useQuery({
    queryKey: [SchoolService.queries.GET_SCHOOL_STUDENT_BIO],
    queryFn: SchoolService.studentBio,
  });
  const nis = dataNis?.data?.nis ?? "";

  const { data, isPending } = useQuery({
    queryKey: [FinanceService.queries.GET_FINANCE_BILLS_PAID_OF, nis],
    queryFn: () => FinanceService.billsPaidOf({ nis }),
  });

  useEffect(() => {
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Utang",
    });
    setBottomNavigation("home");
  }, [setHeader, setBottomNavigation]);

  return (
    <>
      <div className="tw-px-4 tw-pb-20">
        <div className="tw-bg-other-100 tw-rounded-lg card-body tw-mt-3">
          {isPending ? (
            <div className="tw-text-center">
              <Spiner />
            </div>
          ) : (
            <>
              {data?.data?.filter((item) => item.jenis === "utang") != null &&
              data.data?.filter((item) => item.jenis === "utang").length > 0 &&
              data?.data.filter((item) => item.jenis === "utang") ? (
                <>
                  {data?.data
                    .filter((item) => item.jenis === "utang")
                    .map((item, idx) => (
                      <div
                        className="tw-border-solid tw-border-x-0 tw-border-y-1 tw-border-y-other-200 tw-py-1 tw-mb-0.5"
                        key={idx}
                      >
                        <div className="tw-flex tw-justify-between tw-items-center tw-font-semibold">
                          <div className="tw-text-xs tw-font-medium tw-text-other-600">
                            tagihan
                          </div>
                        </div>
                        <div className="tw-flex tw-justify-between tw-items-center tw-font-semibold">
                          <div
                            className="tw-text-sm"
                            style={{
                              maxWidth: "50%",
                            }}
                          >
                            {item.tagihan} - {item.tahunAjaran}
                          </div>
                          <div className="tw-w-1/2 tw-text-end">
                            <div className="tw-text-sm">
                              {toRp(item.nominal)}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                </>
              ) : (
                <div className="tw-p-8 tw-text-center ">
                  <FcFinePrint size={50} />
                  <div>Tidak ada tagihan</div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
};
